/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Referral_BannerInputs */

const en_signup_referral_banner = /** @type {(inputs: Signup_Referral_BannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You were invited by a friend! Sign up for special benefits.`)
};

const de_signup_referral_banner = /** @type {(inputs: Signup_Referral_BannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du wurdest von einem Freund eingeladen! Registriere dich fuer besondere Vorteile.`)
};

const fr_signup_referral_banner = /** @type {(inputs: Signup_Referral_BannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous avez ete invite par un ami ! Inscrivez-vous pour des avantages speciaux.`)
};

const es_signup_referral_banner = /** @type {(inputs: Signup_Referral_BannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fuiste invitado por un amigo. Registrate para obtener beneficios especiales.`)
};

const it_signup_referral_banner = /** @type {(inputs: Signup_Referral_BannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sei stato invitato da un amico! Registrati per vantaggi speciali.`)
};

const nl_signup_referral_banner = /** @type {(inputs: Signup_Referral_BannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je bent uitgenodigd door een vriend! Registreer je voor speciale voordelen.`)
};

const pl_signup_referral_banner = /** @type {(inputs: Signup_Referral_BannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zostales zaproszony przez znajomego! Zarejestruj sie, aby uzyskac specjalne korzysci.`)
};

const fi_signup_referral_banner = /** @type {(inputs: Signup_Referral_BannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ystava kutsui sinut! Rekisteroidy saadaksesi erityisetuja.`)
};

const da_signup_referral_banner = /** @type {(inputs: Signup_Referral_BannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du blev inviteret af en ven! Tilmeld dig for saerlige fordele.`)
};

const sv_signup_referral_banner = /** @type {(inputs: Signup_Referral_BannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du blev inbjuden av en vaen! Registrera dig foer speciella foermaaner.`)
};

/**
* | output |
* | --- |
* | "You were invited by a friend! Sign up for special benefits." |
*
* @param {Signup_Referral_BannerInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const signup_referral_banner = /** @type {((inputs?: Signup_Referral_BannerInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Referral_BannerInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_signup_referral_banner(inputs)
	if (locale === "fr") return fr_signup_referral_banner(inputs)
	if (locale === "es") return es_signup_referral_banner(inputs)
	if (locale === "it") return it_signup_referral_banner(inputs)
	if (locale === "nl") return nl_signup_referral_banner(inputs)
	if (locale === "pl") return pl_signup_referral_banner(inputs)
	if (locale === "fi") return fi_signup_referral_banner(inputs)
	if (locale === "da") return da_signup_referral_banner(inputs)
	if (locale === "sv") return sv_signup_referral_banner(inputs)
	return en_signup_referral_banner(inputs)
});